import { colors } from "./colors"
import { color } from "@ninjaone/themes/base"
import spacing from "./spacing"

const light = {
  name: "light",
  color,
  palette: {
    base: colors.white,
    contrast: colors.ninjaDark,

    primary: {
      light: colors.ninjaLight,
      base: colors.ninjaMedium,
      dark: colors.ninjaDark,
    },
    secondary: {
      light: colors.ninjaLight,
      base: colors.ninjaMedium,
      dark: colors.ninjaDark,
    },
    accent: {
      light: colors.ninjaLightBlue,
      base: colors.ninjaBlueSaturated,
      dark: colors.ninjaBlue,
    },
  },
  spacing,
}

export default light
